export default __webpack_public_path__ + "static/media/top_w576down_3.2bf06883.png";